module.exports = __webpack_public_path__ + "img/V2 - C.8cb9f22d.png";